export const generateUrlWithQueryParams = (baseUrl: string, params: Record<string, string>) => {
  let url = baseUrl + "?";
  Object.entries(params).forEach(([key, value]) => {
    url += `${key}=${value}&`;
  });
  return url.slice(0, -1);
};
